import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { ROLES } from 'utils/constants/index'
import { getRole } from 'utils/common-services/session.services'
import { toggleTheme } from 'redux-thunk/redux/slices/theme.slice'
import { adminLogout } from 'redux-thunk/thunk/auth.thunk'
import { fetchAllOperators, operatorLogout } from 'redux-thunk/thunk/operators.thunk'
import { fetchAllCurrencies } from 'redux-thunk/thunk/currency.thunk'
import { setSelectedCurrency } from 'redux-thunk/redux/slices/currency.slice'
import { fetchAllClients } from 'redux-thunk/thunk/clients.thunk'
import { getGamesList } from 'redux-thunk/thunk/gameSettings.thunk'

const NAV_MENU_OPTIONS = {
  logout: 'logout',
  settings: 'settings',
  profile: 'profile'
}

export const useHeaderController = ({ handleLanguageChange }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { i18n } = useTranslation()

  const [anchorElUser, setAnchorElUser] = useState(null)
  const [anchorElLanguage, setAnchorElLanguage] = useState(null)

  const currentTheme = useSelector((state) => state.theme.mode)
  const isSideNavOpen = useSelector((state) => state.ham.openHam)
  const operatorId = useSelector((state) => state.auth?.loginData?.operatorId)
  const selectedLanguage = useSelector((state) => state.auth.language)
  const allCurrencies = useSelector((state) => state.currencies.currencyData?.rows)
  const selectedCurrency = useSelector((state) => state.currencies.selectedCurrency)

  const isOperator = getRole() === ROLES.OPERATOR

  useEffect(() => {
    dispatch(fetchAllCurrencies({
      perPage: 210,
      page: 1
    }))
    dispatch(fetchAllOperators({
      perPage: 1000,
      page: 1
    }))
    dispatch(fetchAllClients({
      perPage: 1000,
      page: 1
    }))
    dispatch(getGamesList())
  }, [])

  useEffect(() => {
    if (allCurrencies && allCurrencies.length > 0) {
      const primaryCurrency = allCurrencies?.find((currency) => currency.primary)
      if (primaryCurrency) {
        dispatch(setSelectedCurrency(primaryCurrency.id))
      } else {
        dispatch(setSelectedCurrency(allCurrencies[0].id))
      }
    }
  }, [allCurrencies])

  const currencyList = useMemo(
    () =>
      allCurrencies
        ?.filter((currency) => currency.code.trim())
        ?.map((item) => ({
          label: item.name,
          id: item.id,
          value: item.id
        })),
    [allCurrencies]
  )

  const handleCurrencyChange = (event) => {
    const newCurrencyId = event.target.value
    dispatch(setSelectedCurrency(newCurrencyId))
  }

  const handleLogout = () => {
    if (isOperator || operatorId) {
      dispatch(operatorLogout({ navigate }))
    } else {
      dispatch(adminLogout({ navigate }))
    }
  }

  const toggleThemeHandler = () => {
    dispatch(toggleTheme())
  }

  const handleChangeLanguage = (languageCode) => {
    handleLanguageChange(languageCode)
    setAnchorElLanguage(null)
    i18n.changeLanguage(languageCode)
  }

  const toggleLanguageMenu = (event, closeMenu) => {
    if (closeMenu) {
      setAnchorElLanguage(null)
    } else {
      setAnchorElLanguage(event.currentTarget)
    }
  }

  const toggleUserMenu = (event, closeMenu) => {
    if (closeMenu) {
      setAnchorElUser(null)
    } else {
      setAnchorElUser(event.currentTarget)
    }
  }

  const logoutHandler = () => {
    localStorage.removeItem('recentTabs')
    handleLogout()
  }

  return {
    anchorElUser,
    selectedLanguage,
    isSideNavOpen,
    currentTheme,
    toggleUserMenu,
    t,
    navigate,
    NAV_MENU_OPTIONS,
    setAnchorElUser,
    anchorElLanguage,
    handleChangeLanguage,
    toggleLanguageMenu,
    logoutHandler,
    toggleThemeHandler,
    handleLogout,
    selectedCurrency,
    handleCurrencyChange,
    allCurrencies,
    currencyList
  }
}
